



//const Serverurl= ["http://localhost/xampp/Projects/globalbuzzfinal/"]


const Serverurl= ["https://quotationmaker.globalbuzz.in/ajaxapi/"]



export default Serverurl;






